<template>
  <div class="content_box">
    <div class="industryCode" id="ManageTable">
      <div class="industryCode_header">
        <div class="industryCode_logo">
          <img
            style="width: 29px; height: 29px"
            src="@/assets/imgs/icon/region_classify.png"
            alt
          />
        </div>
        <h3>报表统计</h3>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="按地区" name="regionClassify"> </el-tab-pane>
        <el-tab-pane label="按报表" name="reportClassify"> </el-tab-pane>
        <el-tab-pane label="按行业" name="industryClassify"> </el-tab-pane>
        <el-tab-pane label="按企业注册类型" name="cnterpriseClassify">
        </el-tab-pane>
      </el-tabs>
      <div
        style="
          border-bottom: 1px solid rgba(155, 155, 155, 0.25);
          margin-bottom: 20px;
        "
      >
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="报表">
            <el-select v-model="formInline.code" placeholder="请选择">
              <el-option label="重点监测企业产值表" value="001"></el-option>
              <el-option label="重点监测企业财务表" value="002"></el-option>
              <el-option label="工业园区基本情况表" value="003"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="填报期">
            <el-date-picker
              format="yyyy-MM"
              value-format="yyyy-MM"
              v-model="formInline.date_range"
              type="month"
              :clearable="false"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit"
              class="bg5584FF formBotton"
              >查询</el-button
            >
            <el-button type="info" @click="reset" class="formBotton"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-link style="margin-bottom: 20px" type="primary" @click="exportData">{{
        exportLabel
      }}</el-link>
      <el-table
        border
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        v-loading="loading"
      >
        <el-table-column
          align="center"
          :label="`${tableDate}《${tableForm}》报送情况`"
          center
        >
          <el-table-column prop="region" label="区（市）县"> </el-table-column>
          <el-table-column :label="`${tableName}数（户）`">
            <template slot-scope="scope">
              <span class="detail" @click="toDetail(scope.row, 'all')">{{
                scope.row.count
              }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="`已上报${tableName}`">
            <el-table-column prop="ysbCount" label="个数（户）">
              <template slot-scope="scope">
                <span class="detail" @click="toDetail(scope.row, 'ysb')">{{
                  scope.row.ysbCount
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ysbScale" label="占比（%）">
            </el-table-column>
          </el-table-column>
          <el-table-column :label="`未上报${tableName}`">
            <el-table-column prop="unReportNum" label="个数（户）">
              <template slot-scope="scope">
                <span class="detail" @click="toDetail(scope.row, 'wsb')">{{
                  scope.row.wsbCount
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="wsbScale" label="占比（%）">
            </el-table-column>
          </el-table-column>
          <el-table-column prop="yshCount" label="已审核（张）">
            <template slot-scope="scope">
              <span class="detail" @click="toDetail(scope.row, 'ysh')">{{
                scope.row.yshCount
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shbtgCount" label="审核未通过（张）">
            <template slot-scope="scope">
              <span class="detail" @click="toDetail(scope.row, 'shbtg')">{{
                scope.row.shbtgCount
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sqxgCount"
            :label="`申请修改${tableName}（户）`"
          >
            <template slot-scope="scope">
              <span class="detail" @click="toDetail(scope.row, 'sqxg')">{{
                scope.row.sqxgCount
              }}</span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-dialog
        title="信息一览"
        :visible.sync="showDialogVisible"
        :close-on-click-modal="false"
        class="titleChange"
        width="80%"
      >
        <div style="font-size: 18px; margin-bottom: 20px">
          {{ tableNames }}数：<span style="color: #5584ff">{{
            totalSelect
          }}</span
          >户<span style="padding-right: 16px"></span>报表数：<span
            style="color: #5584ff"
            >{{ totalSelect }}</span
          >张
        </div>
        <div
          style="
            border-bottom: 1px solid rgba(155, 155, 155, 0.25);
            margin-bottom: 20px;
          "
        >
          <el-form
            :inline="true"
            :model="formInlineTable"
            class="demo-form-inline"
          >
            <el-form-item :label="`${tableNames}名`">
              <el-input
                v-model="formInlineTable.name"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="报表">
              <el-select v-model="formInlineTable.code" placeholder="请选择">
                <el-option label="重点监测企业产值表" value="001"></el-option>
                <el-option label="重点监测企业财务表" value="002"></el-option>
                <el-option label="工业园区基本情况表" value="003"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="催报次数">
              <el-input
                v-model="formInlineTable.count"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="onSubmits"
                class="bg5584FF formBotton"
                >查询</el-button
              >
              <el-button type="info" @click="resets" class="formBotton"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div style="margin-bottom: 20px">
          <el-button
            type="primary"
            @click="toPass(selectRow)"
            class="bg5584FF"
            v-if="status !== 'ysb' && status !== 'ysh'"
            >批量催报</el-button
          >
        </div>
        <el-link
          style="margin-bottom: 20px"
          type="primary"
          @click="exportDatas"
          >{{ exportLabel }}</el-link
        >
        <el-table
          border
          :data="tableSelectData"
          stripe
          style="width: 100%"
          :header-cell-style="{ background: '#5aa1e2', color: '#ffffff' }"
          v-loading="selectLoading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            :selectable="handleSelection"
            type="selection"
            width="55"
          >
          </el-table-column>
          <el-table-column prop="company_name" :label="`${tableNames}名`">
          </el-table-column>
          <el-table-column prop="name" label="报表名称"> </el-table-column>
          <el-table-column prop="date_range" label="填报期"> </el-table-column>
          <el-table-column prop="status" label="填报状态"> </el-table-column>
          <el-table-column prop="count" label="催报次数"> </el-table-column>
          <el-table-column prop="crt_time" label="上报时间">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.crt_time).format("YYYY-MM-DD HH:mm:ss")
              }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBox">
          <el-pagination
            background
            @size-change="handleSizeChanges"
            @current-change="handleCurrentChanges"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="[20, 30, 50, 100]"
            layout="sizes, prev, pager, next, jumper"
            :total="totalSelect"
          >
          </el-pagination>
        </div>
      </el-dialog>
      <el-dialog
        title="发送催报"
        :visible.sync="passDialogVisible"
        :close-on-click-modal="false"
        class="titleChange"
        width="770px"
      >
        <el-form
          :model="passForm"
          :rules="rules"
          ref="passForm"
          label-width="135px"
          class="demo-RuleForm"
          size="small"
          v-loading="passLoading"
        >
          <el-form-item label="报表催报意见：" prop="reason">
            <el-input v-model="passForm.reason" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <div class="btnBox">
          <el-button type="primary" @click="surePass()">确定</el-button>
          <el-button @click="passDialogVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { export2Excel } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      activeName: "regionClassify",
      tempData: {
        region: "区（市）县",
        enterpriseNum: "310",
        reportNum: "192",
        reportPercentage: "60%",
        unReportNum: "98",
        unReportPercentage: "30%",
        finishNum: "43",
        unFinishNum: "100",
        applyNum: "20",
      }, //模板数据  正式使用请删除
      tempDatas: {
        enterpriseName: "某公司",
        formName: "产值表",
        tbTime: "2019年12月",
        tbStatu: "已上报",
        times: "0",
        sbTime: "2020-01-02 11:11:11",
      },
      tableSelectData: [],
      tableData: [],
      formInlineTable: {},
      currentPage: 1,
      currentPages: 1,
      loading: false,
      expName: "",
      formInline: {
        //查询对象
        code: "",
        date_range: "",
      },
      rules: {
        //表单验证规则
        reason: [{ required: true, message: "请输入意见", trigger: "blur" }],
      },
      pageSize: 20,
      exportLabel: "<<点击此处可导出报表",
      passForm: {},
      passLoading: false,
      showObj: {},
      tableForm: "",
      tableDate: "",
      selectLoading: false,
      total: 0, //表格总数
      totalSelect: 0, //表格总数
      // total: 0, //表格总数
      detailDialogVisible: false,
      selectRow: [],
      status: "",
      passDialogVisible: false,
      showDialogVisible: false,
      tableName: "企业",
      tableNames: "企业",
      name: "",
    };
  },
  methods: {
    handleSelection(row) {
      if (row.status == "审核通过" || row.status == "未审核") {
        return false;
      } else {
        return true;
      }
    },
    handleClick() {
      if (this.activeName !== "regionClassify") {
        this.$router.push("/index/workbench/" + this.activeName);
      }
    },
    getdata() {
      this.loading = true;
      this.tableData = [];
      const param = {};
      param["code"] = this.formInline.code;
      this.tableDate = this.$moment(this.formInline.date_range).format(
        "YYYY年MM月"
      );
      if (this.formInline.code == "001") {
        this.tableName = "企业";
        this.tableForm = "重点监测企业产值表";
      } else if (this.formInline.code == "002") {
        this.tableName = "企业";
        this.tableForm = "重点监测企业财务表";
      } else if (this.formInline.code == "003") {
        this.tableForm = "工业园区基本情况表";
        this.tableName = "园区";
      }
      if (this.formInline.date_range !== "") {
        param["date_range"] = this.formInline.date_range;
      }
      this.$axios
        .post("/business/insertMonitor/toRegionStatistics", param)
        .then((res) => {
          res.data.forEach((temp) => {
            temp.ysbScale =
              temp.count != 0
                ? (
                    Math.round((temp.ysbCount / temp.count) * 10000) / 100.0
                  ).toFixed(1)
                : "--";
            temp.wsbScale =
              temp.count != 0
                ? (
                    Math.round((temp.wsbCount / temp.count) * 10000) / 100.0
                  ).toFixed(1)
                : "--";
            temp.region = temp.region || "";
            temp.region_code = temp.region_code || "";
          });
          this.tableData = res.data;
          this.loading = false;
        });
    },
    getdatas(page) {
      this.selectLoading = true;
      this.tableSelectData = [];
      const param = {
        page: page || 1,
        pageSize: this.pageSize,
        status: this.status,
        region: this.name,
        date_range: this.formInline.date_range,
      };
      if (this.formInlineTable.code !== "") {
        param["code"] = this.formInlineTable.code;
      }
      if (this.formInlineTable.code == "003") {
        this.tableNames = "园区";
      } else {
        this.tableNames = "企业";
      }
      if (this.formInlineTable.name !== "") {
        param["name"] = this.formInlineTable.name;
      }
      if (this.formInlineTable.count !== "") {
        param["count"] = this.formInlineTable.count;
      }
      this.$axios
        .post("/business/insertMonitor/showCompanyByRegion", param)
        .then((res) => {
          res.data.forEach((temp) => {
            temp.crt_time = this.$moment(temp.crt_time).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            if (this.status == "sqxg") {
              if (temp.sqxg_status == "2") {
                temp.status = "待修改";
              } else {
                temp.status = "已上报";
              }
            } else {
              if (temp.status == "4" && temp.sqxg_status != "2") {
                temp.status = "审核通过";
              } else if (temp.status == "5" && temp.sqxg_status != "2") {
                temp.status = "审核未通过";
              } else if (temp.status == "3" && temp.sqxg_status != "2") {
                temp.status = "未审核";
              } else if (temp.sqxg_status == "2") {
                temp.status = "待修改";
              } else if (temp.status < "3") {
                temp.status = "未上报";
              }
            }
          });
          this.tableSelectData = res.data;
          this.totalSelect = res.total;
          this.selectLoading = false;
        });
    },
    toDetail(row, status) {
      this.status = status;
      this.expName = row.region;
      this.name = row.region_code;
      this.formInlineTable = {
        code: this.formInline.code,
      };
      this.getdatas();
      this.showDialogVisible = true;
    },
    handleCurrentChanges(val) {
      this.getdatas(val);
    },
    handleSizeChanges(val) {
      this.pageSize = val;
      this.getdatas();
    },
    onSubmit() {
      this.getdata();
    },
    onSubmits() {
      this.getdatas();
    },
    reset() {
      this.formInline = {
        //查询对象
        code: "001",
        date_range: this.$moment(new Date()).format("YYYY-MM"),
      };
      this.getdata();
    },
    resets() {
      this.formInlineTable = {};
      this.formInlineTable.code = this.formInline.code;
      this.getdatas();
    },
    handleSelectionChange(rowTable) {
      this.selectRow = [];
      rowTable.forEach((temp) => {
        this.selectRow.push(temp.id);
      });
    },
    toPass(rowList) {
      if (rowList.length) {
        this.selectRow = rowList;
        this.passForm = {
          reason: "",
        };
        this.passDialogVisible = true;
      }
    },
    surePass() {
      this.$refs.passForm.validate((valid) => {
        if (valid) {
          this.passLoading = true;
          const param = {
            desc: this.passForm.reason,
            id: this.selectRow,
          };
          this.$axios
            .put("/business/insertMonitor/insertIntoUrgeToReport", param)
            .then((res) => {
              this.$message.success("催报成功");
              this.getdatas(1);
              this.passLoading = false;
              this.passDialogVisible = false;
            });
        }
      });
    },
    exportData() {
      let column = [
        {
          title: "区（市）县",
          key: "region",
          rowspan: 2,
        },
        {
          title: `${this.tableName}数（户）`,
          key: "count",
          rowspan: 2,
        },

        {
          title: `已上报${this.tableName}`,
          data: [
            {
              title: "个数（户）",
              key: "ysbCount",
            },
            {
              title: "占比（%）",
              key: "ysbScale",
            },
          ],
          colspan: 2,
        },
        {
          title: `未上报${this.tableName}`,
          data: [
            {
              title: "个数（户）",
              key: "wsbCount",
            },
            {
              title: "占比（%）",
              key: "wsbScale",
            },
          ],
          colspan: 2,
        },
        {
          title: "已审核（张）",
          key: "yshCount",
          rowspan: 2,
        },
        {
          title: "审核不通过（张）",
          key: "shbtgCount",
          rowspan: 2,
        },
        {
          title: `申请修改${this.tableName}（户）`,
          key: "sqxgCount",
          rowspan: 2,
        },
      ];
      export2Excel(
        column,
        this.tableData,
        `${this.tableDate}《${this.tableForm}》报送情况`
      );
    },
    exportDatas() {
      let column = [
        {
          title: `${this.tableNames}名`,
          key: "company_name",
        },
        {
          title: "报表名称",
          key: "name",
        },
        {
          title: "填报期",
          key: "date_range",
        },
        {
          title: "填报状态",
          key: "status",
        },
        {
          title: "催报次数",
          key: "count",
        },
        {
          title: "上报时间",
          key: "crt_time",
        },
      ];
      export2Excel(column, this.tableSelectData, this.expName);
    },
  },
  created() {
    this.reset();
  },
};
</script>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.industryCode {
  box-shadow: 0px 0px 50px #ccc;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .industryCode_header {
    height: 31px;
    width: 100%;
    display: flex;
    margin-bottom: 30px;
    .industryCode_logo {
      margin: 2px 20px 0 2px;
    }
    h3 {
      font-size: 24px;
      height: 100%;
      margin: 0;
      color: #444444;
    }
  }
  .industryCode_form {
    height: 70px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(155, 155, 155, 0.25);
    margin-bottom: 20px;
    .el-form {
      .el-form-item {
        margin-right: 30px;
      }
    }
  }
  .industryCode_add_user {
    margin-bottom: 20px;
  }
  .el-dialog {
    .addUser {
      .el-form-item {
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
</style>